export const pastelColors = [
  '#FFD7E9', // Soft pink
  '#D4E2FF', // Light blue
  '#E8F5E9', // Light green
  '#FFF3E0', // Light orange
  '#E8E4FF'  // Light purple
];
